<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      1.1 {{ $t('common_words.company_general_info') }}
    </p>
    <hr />
    <br />
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-2">
        <fg-input
          type="number"
          v-model="model.nit"
          :label="`${$t('common_words.nit')}: *`"
          name="common_words.nit"
          v-validate="modelValidations.nit"
          :error="getError('common_words.nit', true)"
          placeholder="800.000.000 – 9"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          placeholder="XXX SAS"
        >
        </fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-2">
        <fg-input
          type="number"
          :label="`${$t('common_words.phone')}: *`"
          v-model="model.phone"
          name="common_words.phone"
          v-validate="modelValidations.phone"
          :error="getError('common_words.phone', true)"
          placeholder="300-xxx-xxxx"
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4">
        <fg-input
          type="email"
          :label="`${$t('common_words.email')}: *`"
          name="common_words.email"
          v-validate="modelValidations.email"
          v-model="model.email"
          :error="getError('common_words.email', true)"
          placeholder="xxxx@gmail.com"
        >
        </fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-6 col-lg-7 col-xl-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.comercial_name')}: `"
          v-model="model.tradename"
          placeholder="..."
        ></fg-input>
      </div>
      <div class="col-12 col-sm-6 col-md-6 col-lg-5 col-xl-6">
        <fg-input
          type="text"
          :label="`${$t('common_words.website')}: `"
          placeholder="https://xxxxxx.com"
          v-model="model.web_site"
        ></fg-input>
      </div>
      <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
        <fg-input
          type="text"
          :label="`${$t('common_words.icon')}: `"
          placeholder="icono.svg"
          v-model="model.icon"
        ></fg-input>
      </div> -->
      <div class="col-12">
        <div class="form-group has-label">
          <div class="form-group has-label">
            <label>{{ $t('common_words.economic_activity') }}:</label>
            <br />
            <el-input
              maxlength="150"
              show-word-limit
              class="shadow-sm"
              type="textarea"
              :rows="2"
              :placeholder="`${$t('common_words.economic_activity_enter')}...`"
              v-model="model.comercial_activity"
            ></el-input>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  data() {
    return {
      model: {
        id: null,
        nit: null,
        name: null,
        phone: null,
        email: null,
        tradename: null,
        web_site: null,
        icon: null,
        comercial_activity: null,
      },
      modelValidations: {
        nit: {
          required: true,
        },
        name: {
          required: true,
        },
        phone: {
          required: true,
          numeric: true,
        },
        email: {
          required: true,
          email: true,
        },
      },
    };
  },
  mixins: [MixinPermissions, mixinMasters, MixinForm],
  methods: {
    opty(dataMain, options) {
      const others = [];
      dataMain.forEach((element) => {
        const isFind = options.find((item) => item.id === element);
        if (isFind) others.push(isFind.name);
      });

      return others;
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', {
          ...this.model,
          nit: this.model.nit,
          name: this.model.name,
          phone: this.model.phone,
          email: this.model.email,
          tradename: this.model.tradename,
          web_site: this.model.web_site,
          icon: null,
          comercial_activity: this.model.comercial_activity,
        });

        return res;
      });
    },
  },

  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      let editForm = {};
      if (this.isUpdate() && sessionStorage.getItem('editForm')) {
        editForm = JSON.parse(sessionStorage.getItem('editForm'));
        this.model.id = editForm.id;
        this.model.nit = editForm.nit;
        this.model.name = editForm.name;
        this.model.phone = editForm.phone;
        this.model.email = editForm.email;
        this.model.tradename = editForm.tradename;
        this.model.web_site = editForm.web_site;
        this.model.icon = null;
        this.model.comercial_activity = editForm.comercial_activity;
      }
      setTimeout(() => {
        this.showHideLoading();
      }, 1000);
    } else this.showHideLoading();
  },
};
</script>
<style></style>
